import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import CustomLoader from "../custom-components/CustomLoader";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../slices/user-slice";
import { UserServiceImpl } from "../services/UserServiceImpl";
import { SubscriptionServiceImpl } from "../services/SubscriptionServiceImpl";
import { useAppDispatch } from "../custom-hooks/useAppDispatch";
import AuthRoutes from "../routes/AuthenticatedRoutes";
import NotFound from "./pages/not-found/NotFound";
import { useErrorHandler } from "../custom-hooks/base-hooks/useErrorHandler";
import Login from "./pages/login/Login";
import Registration from "./pages/registration/Registration";
import Main from "./pages/main/Main";
import Catalog from "./pages/catalog/Catalog";
import Contacts from "./pages/contacts/Contacts";
import Documents from "./pages/documents/Documents";

const MainRedirect = () => {
    const { search, hash } = useLocation();

    return <Navigate to={{ pathname: "/", search, hash }} replace />;
};

function App() {
    const dispatch = useAppDispatch();
    const { isLoading } = useErrorHandler();
    const user = useSelector(selectUser());
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                await Promise.all([
                    dispatch(UserServiceImpl.getUserThunk()),
                    dispatch(SubscriptionServiceImpl.getAllSubscriptionsThunk()),
                ]);
            } finally {
                setInitialized(true);
            }
        })();
    }, []);

    return (
        <>
            <CustomLoader isVisible={isLoading()} />
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/main" element={<MainRedirect />} />
                {initialized && <Route path="/catalog" element={<Catalog />} />}
                <Route path="/login" element={<Login />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/not-found" element={<NotFound />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/documents" element={<Documents />} />
                {initialized && (
                    <Route path="/*" element={user.id ? <AuthRoutes /> : <Navigate to="/login" replace />} />
                )}
            </Routes>
        </>
    );
}

export default App;
